<template>
  <div>
    <a-row :gutter="24">
      <a-col :span="12">
        <a-form-item label="图片上传">
          <j-image-upload v-model="imgList"></j-image-upload>
        </a-form-item>
      </a-col>
      <a-col :span="12">选中的值(v-model)：{{ imgList }}</a-col>
    </a-row>
    <a-row :gutter="24" style="margin-top: 65px; margin-bottom: 50px">
      <a-col :span="12">
        <a-form-item label="文件上传">
          <j-upload v-model="fileList"></j-upload>
        </a-form-item>
      </a-col>
      <a-col :span="12">
        选中的值(v-model)：
        <j-ellipsis :value="fileList" :length="30" v-if="fileList.length > 0" />
      </a-col>
    </a-row>

    <index-chart v-if="indexStyle == 1"></index-chart>
    <index-bdc v-if="indexStyle == 2"></index-bdc>
    <index-task v-if="indexStyle == 3"></index-task>
    <div style="width: 100%; text-align: right; margin-top: 20px">
      请选择首页样式：
      <a-radio-group v-model="indexStyle">
        <a-radio :value="1">统计图表</a-radio>
        <a-radio :value="2">统计图表2</a-radio>
        <a-radio :value="3">任务表格</a-radio>
      </a-radio-group>
    </div>
    <div class="area">
      <div>
        <span class="imp">1. 二级联动（不带“全部”选项）</span>
        <a-cascader size="large" :options="provinceAndCityData" v-model="selectedOptions1" @change="handleChange">
        </a-cascader>
      </div>
      <div class="bind">
        <div>绑定值：{{ selectedOptions1 }}</div>
        <div>区域码转汉字：{{ CodeToText[selectedOptions1[0]] }},{{ CodeToText[selectedOptions1[1]] }}</div>
        <div>
          汉字转区域码：{{ convertTextToCode(CodeToText[selectedOptions1[0]], CodeToText[selectedOptions1[1]]) }}
        </div>
      </div>
      <div class="three">
        <span class="imp">2. 二级联动(带有“全部”选项)</span>
        <a-cascader size="large" :options="provinceAndCityDataPlus" v-model="selectedOptions3" @change="handleChange">
        </a-cascader>
      </div>
      <div class="bind">
        <div>绑定值：{{ selectedOptions3 }}</div>
        <div>区域码转汉字：{{ CodeToText[selectedOptions3[0]] }},{{ CodeToText[selectedOptions3[1]] }}</div>
        <div>
          汉字转区域码：{{ convertTextToCode(CodeToText[selectedOptions3[0]], CodeToText[selectedOptions3[1]]) }}
        </div>
      </div>
      <div class="three">
        <span class="imp">3. 三级联动（不带“全部”选项）</span>
        <a-cascader class="long" size="large" :options="regionData" v-model="selectedOptions2" @change="handleChange">
        </a-cascader>
      </div>
      <div class="bind">
        <div>绑定值：{{ selectedOptions2 }}</div>
        <div>
          区域码转汉字：{{ CodeToText[selectedOptions2[0]] }},{{ CodeToText[selectedOptions2[1]] }},{{
            CodeToText[selectedOptions2[2]]
          }}
        </div>
        <div>
          汉字转区域码：{{
            convertTextToCode(
              CodeToText[selectedOptions2[0]],
              CodeToText[selectedOptions2[1]],
              CodeToText[selectedOptions2[2]]
            )
          }}
        </div>
      </div>
      <div class="three">
        <span class="imp">4. 三级联动(带"全部选项")</span>
        <a-cascader
          size="large"
          class="long"
          :options="regionDataPlus"
          v-model="selectedOptions4"
          @change="handleChange"
        >
        </a-cascader>
      </div>
      <div class="bind">
        <div>绑定值：{{ selectedOptions4 }}</div>
        <div>
          区域码转汉字：{{ CodeToText[selectedOptions4[0]] }},{{ CodeToText[selectedOptions4[1]] }},{{
            CodeToText[selectedOptions4[2]]
          }}
        </div>
        <div>
          汉字转区域码：{{
            convertTextToCode(
              CodeToText[selectedOptions4[0]],
              CodeToText[selectedOptions4[1]],
              CodeToText[selectedOptions4[2]]
            )
          }}
        </div>
      </div>
    </div>
    <!-- <a-form-item label="职业分类" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-select-position placeholder="请选择职业分类" :multiple="false" v-decorator="['post', {}]"/>
        </a-form-item> -->
  </div>
</template>

<script>
import JUpload from '@/components/jeecg/JUpload'
import JImageUpload from '@/components/jeecg/JImageUpload'
import IndexChart from './IndexChart'
import IndexTask from './IndexTask'
import IndexBdc from './IndexBdc'
import store from '@/store'
import Vue from 'vue'
import { AREA_INFO } from '@/store/mutation-types'
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode
} from '../../components/jeecg/area'
import JSelectPosition from '@/components/jeecgbiz/JSelectPosition'
export default {
  name: 'Analysis',
  components: {
    IndexChart,
    IndexTask,
    IndexBdc,
    JSelectPosition,
    JImageUpload,
    JUpload
  },
  data() {
    return {
      indexStyle: 1,
      CodeToText,
      TextToCode,
      BeiJing: CodeToText['110000'],
      provinceAndCityData,
      provinceAndCityDataPlus,
      regionData,
      regionDataPlus,
      selectedOptions1: ['110000', '110100'],
      selectedOptions2: ['120000', '120100', '120101'],
      selectedOptions3: ['130000', ''],
      selectedOptions4: ['120000', '120100', ''],
      fileList: [],
      imgList: []
    }
  },
  created() {
    this.initArea()
  },
  methods: {
    initArea() {
      store
        .dispatch('GetArea', null)
        .then((res) => {
          // if (res.success) {
          //   const areaInfo = Vue.ls.get(AREA_INFO)
          // }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleChange(value) {
      console.log(value)
    },
    convertTextToCode(provinceText, cityText, regionText) {
      let code = ''
      if (provinceText && this.TextToCode[provinceText]) {
        const province = this.TextToCode[provinceText]
        code += province.code + ', '
        if (cityText && province[cityText]) {
          const city = province[cityText]
          code += city.code + ', '
          if (regionText && city[regionText]) {
            code += city[regionText].code
          }
        }
      }
      return code
    }
  },
  mounted() {
    console.log(this.TextToCode['北京市'].code)
    console.log(this.TextToCode['北京市']['北京市'].code)
    console.log(this.TextToCode['北京市']['北京市']['朝阳区'].code)
  }
}
</script>

<style>
.long {
  width: 250px;
}
.area {
  padding-top: 50px;
  margin: 0 auto;
  width: 800px;
}
.three {
  margin-top: 100px;
}
.bind {
  margin-top: 20px;
  line-height: 40px;
  text-indent: 15px;
}
.imp {
  color: #409eff;
}
</style>
